import { supabase } from './supabase';
import type { WorkTask } from '@klothiq/domain';

export interface WorkMutationResult {
  success: boolean;
  changed: boolean;
  replayed?: boolean;
  plan_id: string;
  task_id?: string | null;
  comment_id?: string;
  task?: WorkTask;
  plan?: { id: string; version: number; updated_at: string; is_archived: boolean };
}
export const WORK_QUERY_KEYS = [
  'plans',
  'plan_details',
  'my_tasks',
  'task_comments',
  'task_activity',
  'in_app_notifications',
] as const;

export function workErrorMessage(error: unknown): string {
  const value = error as { code?: string; message?: string };
  if (value.code === 'PGRST202' || value.code === '42703')
    return 'The planning database update is required. Apply the matching R0 migration before using this version.';
  return value.message ?? 'This update could not be saved. Your entered details are retained.';
}

export async function workRpc<T>(name: string, args: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw new Error(workErrorMessage(error));
  return data as T;
}
